var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgArrowUp = function SvgArrowUp(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0D2976",
    d: "M10.824 2.335a1.185 1.185 0 0 0-1.651 0L3.342 8.049a1.13 1.13 0 0 0 0 1.618 1.185 1.185 0 0 0 1.65 0L8.835 5.9v10.958C8.834 17.49 9.354 18 10 18s1.166-.51 1.166-1.143V5.9l3.841 3.765a1.185 1.185 0 0 0 1.651 0 1.13 1.13 0 0 0 0-1.618l-5.83-5.715z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgArrowUp);
export default ForwardRef;